//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "FieldFactory",
  props: {
    label: {},
    mask: {},
    filled: {},
    type: {},
    value: {},
    edit: {},
    field: {},
    transactionId: {},
    showEmail: {},
    showPhone: {},
    showGraph: {},
    showGeoHistory: {},
    example: {},
    required: {},
    description: {},
    options: {},
    fields: {},
    data: {},
    caption: {},
    hint: {},
    optionLabel: {},
    optionValue: {},
    initialOptionsParam: {},
    allowNew: {},
    justValue: {},
    mapOptions: {},
    BGColor: {},
    round: {},
    dense: {},
    clearable: {
      defaultValue: true
    },
    disable: {
      defaultValue: false
    },
    multiple: {
      defaultValue: false
    },
    visible: {},
    isDisabled: {
      defaultValue: false
    }
  },
  data: function data() {
    return {
      yesNoOptions: [{
        label: "Yes",
        value: "TRUE"
      }, {
        label: "No",
        value: "FALSE"
      }]
    };
  },
  methods: {
    validate: function validate() {
      if (!this.$refs.input || !this.$refs.input.validate) return true;
      return this.$refs.input.validate();
    }
  },
  computed: {
    hasError: function hasError() {
      return this.$refs.input.hasError;
    }
  }
};